import { render, staticRenderFns } from "./special.vue?vue&type=template&id=9c9836d2&scoped=true&"
import script from "./special.vue?vue&type=script&lang=js&"
export * from "./special.vue?vue&type=script&lang=js&"
import style0 from "./special.vue?vue&type=style&index=0&id=9c9836d2&prod&lang=css&"
import style1 from "./special.vue?vue&type=style&index=1&id=9c9836d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9836d2",
  null
  
)

export default component.exports